<template>
	<CommonHeader class="main_head_block">
		<template v-slot:header>

			<span class="module_heading">Products</span>
			<i class="fas fa-upload icon_one" @click = "importExcel()"></i>
			<i class="fas fa-download icon_two" @click = "exportExcel()"></i>


			<div class="sellerSelector" style="width: 6%; display: flex; align-items: flex-start;">
				<div class="sellerLabel" style="width: auto; padding-right: 10px;">
					SC
				</div>
				<toggle-button
				v-model="isSeller"
				:value="isSeller"
				style="padding-bottom: 5px; margin-left: 0; margin-top: -0.2px;"
				class="form-check-input"
				@input="sellerValueChange($event)"
				@change="onToggleHandler($event)"
			  />
			</div>
			
			<!-- <div class="sellerSelector" style="width: 8%; display: flex; align-items: flex-start;">
				<div class="sellerLabel" style="width: auto; padding-right: 10px;">
					Hidden
				</div>
				<toggle-button
					v-model="showHidden"
					:value="showHidden"
					style="padding-bottom: 5px; margin-left: 0; margin-top: -0.2px;"
					class="form-check-input"
					@input="showHiddenChange($event)"
					@change="onToggleShowHiddenHandler($event)"
				/>
			</div> -->
			
			<div class="sel_fil_wrap one">
				<multiselect
					v-model="selectedVendor"
					:options="vendorsList"
					:show-no-results="true"
					:searchable="true"
					ref="multiselect"
					label="name"
					track-by="name"
					open-direction="bottom"
					:taggable="false"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					selectedLabel = ""
					@select = "resetBrand();setVendor($event);"
					@remove = "resetAllData()"
					/>
			</div>

			<div class="col-md-4 fil_btn">
				<button
					class="btn btn-primary"
					style="font-size: 12px"
					@click="getFilterProducts(true)">Filter</button>
					<span class="data_notice" style="font-size: 14px">* Tag updates may be delayed up to 15 minutes</span>
			</div>
			

			<div class="adv_fil_wrap">
				<productAdvanceFilter @getFilterProducts = "getFilterProducts" ref = "productAdvanceFilter"/>
			</div>
			<div class="head_search">
				<object data='assets/img/search.svg' style="height:18px;width:18px;margin-left:5px;"></object>
			</div>
			<div class="head_search_inp">
				 <input type="search" id="search" class="search" v-model="searchFilterString"  placeholder="Title/Asin/Vendor/Brand" @keyup.enter="getFilterProducts()" style = "border: none;outline:none;padding: 7px 0px 5px 10px;" autocomplete = "off"/>
			</div>

			<ImportTags @closePopUp = "closePopUp"/>
			<ExportFilePopUp @closePopUpExport = "closePopUpExport" :isTimeOut = "isTimeOut" :errorMessage = "errorMessage"/>
		</template>
	</CommonHeader>
</template>

<script>
import Multiselect from "vue-multiselect";
import productAdvanceFilter from "@/components/product/productAdvanceFilter.vue";
import  ImportTags from "@/components/product/ImportTags.vue";
import  ExportFilePopUp from "@/components/product/ExportFilePopUp.vue";
import CommonHeader from "@/components/CommonHeader.vue"

export default {
  name: "ProductListFilter",
  components:{
	  Multiselect,
	  productAdvanceFilter,
	  ImportTags,
	  ExportFilePopUp,
	  CommonHeader
  },
  data() {
    return {
		isSeller:this.$store.state.isSeller,
		showHidden:this.$store.state.showHidden,
		selectedVendor:[],
		allGroupingTitle:'All',
		selectedBrandProfle:[],
		isTimeOut: false,
		errorMessage: '',
		downloadLink: '',
		default_tag_list:[
                { name: 'Brand', value: 'brand_product'},
                { name: 'Style', value: 'style_product'},
                { name: 'Category', value: 'category_product'},
                { name: 'Sub-Category', value: 'sub_category_product'},
                { name: 'Product Group', value: 'product_group_product'},
                { name: 'Size', value: 'size_product'},
                { name: 'Flavor', value: 'flavor_product'},
                { name: 'GL', value: 'gl_product'},
                { name: 'Competitor', value: 'competitor_product'},
                { name: 'Color', value: 'color_product'}
        ],
		tagFilter:[],
		tagFilterOptions: [
			{ name: 'Brand', value: 'brand_product'},
			{ name: 'Category', value: 'category_product'},
			{ name: 'Color', value: 'color_product'},
			{ name: 'Competitor', value: 'competitor_product'},
			{ name: 'Sub-Category', value: 'sub_category_product'},
			{ name: 'Style', value: 'style_product'},
			{ name: 'GL', value: 'gl_product'},
			{ name: 'Product Group', value: 'product_group_product'},
			{ name: 'Abbreviated Title', value: 'abbreviated_title_product'},
			{ name: 'Size', value: 'size_product'},
			{ name: 'Flavor', value: 'flavor_product'}
    ]
    };
  },
  mounted(){
		this.$store.commit("updateIsFilter", false)
		this.$store.dispatch("getAllVendorForProduct")
		this.$store.dispatch("getAllSellersForProduct")
		if(this.$store.state.selectedVendorProduct && this.$store.state.vendorList){
			 let selectedFilter = ''
			this.$store.state.vendorList.filter(item=>{
			if(item && item.id && item.master_id && this.$store.state.selectedVendorProduct){
				let arr = this.$store.state.selectedVendorProduct.split(',')
				if(item.master_id==arr[1]){
					selectedFilter = item
				}
			}
			else if(item && item.id && item.id==this.$store.state.selectedVendorProduct){
				selectedFilter = item
			}
		})
		if(selectedFilter && selectedFilter.go_client_id){
			let payload = {
				go_client_id:selectedFilter.go_client_id
			}
			this.$store.dispatch("getProfileForVendorInProduct",payload)
		  }
		  else{z
			  this.brandProfileList = []
		  }
	  }
	  else{
		  this.$store.dispatch("getProfileForVendorInProduct")
	  }
	  if(this.$store.state.selectedVendorProduct && this.$store.state.vendorList){
		  this.selectedVendor = this.$store.state.vendorList.filter(e => {
			  if(e.master_id && this.$store.state.selectedVendorProduct){
				  let arr = this.$store.state.selectedVendorProduct.split(',')
				  if(e.master_id == arr[1]){
					  return e
				  }
			  }
		})
	  }
	  if(this.$store.state.selectedBrandProduct && this.$store.state.vendorList){
		  this.selectedBrandProfle = this.$store.state.brandProfileList.filter(e => e.id == this.$store.state.selectedBrandProduct)
		}
  },
  methods: {
	onToggleHandler(event){
		this.$store.state.isSeller = event.value
	},
	onToggleShowHiddenHandler(event){
		this.$store.state.showHidden = event.value
	},
	setTagLabel() {
		return 'Tags Selected'
	},
    getFilterProducts(isFilter) {
	  this.$store.state.currentPageNumber = 1
	  this.$store.commit("updateIsFilter", isFilter)
	  this.$store.commit("updateSeller", this.isSeller)
	//   this.$store.commit("updateShowHidden", this.$store.state)
	  this.$store.commit("updateTagFilterOptions", this.tagFilter)
      this.$store.dispatch("product/getAllProducts")
    },
   resetBrand(){
	   this.selectedBrandProfle = [];
	  this.$store.state.selectedBrandProduct = ""
   },
    setVendor(data){
	  	let payload = {
		   go_client_id :data.go_client_id||''
		}
	   if(data.id == "all"){
		   this.resetAllData()
	   }
	   else{
		   if(data.master_id){
			   this.$store.state.selectedVendorProduct = `${data.id},${data.master_id}`
		   }
		   else{
			    this.$store.state.selectedVendorProduct = `${data.id}`
		   }
		   this.$store.state.selectedVendorPartnerUuid = `${data.partneruuid}`
		   this.$store.dispatch("getProfileForVendorInProduct",payload).then((res) => {
		   })
	   }
    },
	setBrand(data){
		if(data.id == "all"){
			this.resetBrandData()
		}
		else{
			this.$store.state.selectedBrandProduct = data.id
		}
	},
	sellerValueChange(){
		this.$store.dispatch("getAllSellersForProduct").then((res) => {
			this.grouping = 'Seller'
		   })
	},
    resetAllData(){
		this.$store.state.selectedVendorProduct = "";
		this.$store.state.selectedVendorPartnerUuid = '';
		this.$store.state.selectedBrandProduct = "";
		this.selectedVendor = [];
		this.$store.state.grouping = "Vendor";
		this.$store.state.selectedTags = [];
		this.selectedBrandProfle = [];
		this.$store.dispatch("getProfileForVendorInProduct")
	},
	resetBrandData(){
		this.$store.state.selectedBrandProduct = "";
		this.selectedBrandProfle = [];
	},
	importExcel(){
		this.$store.commit("updateSeller", this.isSeller)
		window.$("#importTagsData").modal({
			show: true
		});
	},
	closePopUpExport(){
		this.isTimeOut = false
		this.downloadLink = ''
		this.errorMessage = ''
	},
	closePopUp(){
		this.$store.dispatch("product/getAllProducts");
	},
	exportExcel(){
		console.log('EXPORT_EXCEL')
		this.$store.commit("updateSeller", this.isSeller)
		
		let filter_tag_list = this.tagFilter
		if(!filter_tag_list || filter_tag_list.length<1) {
			filter_tag_list = this.default_tag_list
		}
		this.$store.commit("updateTagFilterOptions", filter_tag_list)
		
		let payload = {
			isWithoutPagination:true,
			q: this.$store.state.searchFilterString,
			ams_profile_id: this.$store.state.selectedBrandProduct,
			vendor: this.$store.state.selectedVendorProduct,
			isSeller: this.isSeller,
			tags: this.tagFilter,
			grouping: this.$store.state.grouping,
			sort: this.$store.state.selectedSortOrder,
			category :  ((this.$store.state.product.productAdvanceFilter && this.$store.state.product.productAdvanceFilter.hasOwnProperty('category')) ? this.$store.state.product.productAdvanceFilter.category : null),
			style : ((this.$store.state.product.productAdvanceFilter && this.$store.state.product.productAdvanceFilter.hasOwnProperty('style')) ? this.$store.state.product.productAdvanceFilter.style : null)
		}

		var vm = this;

		this.$store.dispatch("product/getAllProductsForExport", payload).then((response) => {
			
			if(response && response.status == 200){
				vm.isTimeOut = false
				vm.downloadLink = response.data.Location
				vm.errorMessage= response.data.noClientError ? response.data.errorMessage : null
				window.$("#exportFilePopUp").modal({
					show: true
				});
			}
			else{
				vm.isTimeOut = true
				vm.errorMessage = 'Export in progress.. you will receive the .csv file via email shortly.'
				window.$("#exportFilePopUp").modal({
					show: true
				});
			}

		});

	},
	s2ab(s) {
		var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
		var view = new Uint8Array(buf);  //create uint8array as viewer
		for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
		return buf;
	}
  },
  computed: {
	  vendorsList(){
		let ddList = this.isSeller ? this.$store.state.sellerList : this.$store.state.vendorList
		let data = ddList.filter(e=>e.name)
		if(data && data.length && data[0].id!="all")
			data.unshift({id:"all", name:"All"})
		return data
  	},
	showBrandFilter:{
		set(val){
			//
			this.showBrandFilter = val;
		},
		get(){
			return this.$store.state.selectedVendorProduct ? true : false // store getter not giving right response giving old value
		}
	},
    brandProfileList: {
      set(val) {
        this.$store.state.brandProfileList = val;
        this.$store.commit("resetTableFooterFilter");
      },
      get() {
		  let data = this.$store.state.brandProfileList;
			if(data && data.length && data[0].id!="all")
				data.unshift({id:"all", name:"All Brands"})
			return data
      }
    },
    searchFilterString: {
      set(val) {
		if(!val){
			this.$store.state.searchFilterString = val
			this.getFilterProducts();
		}
		else{
			this.$store.state.searchFilterString = val

		}
		this.$store.commit("resetTableFooterFilter");
      },
      get() {
          return this.$store.state.searchFilterString;
      }
    }
  }
};
</script>

<style lang="scss">
.sellerLabel {
	font-weight: bold;
	margin-left: 5px;
	text-align: left;
}
.sellerSelector{
	margin-top: 26px;
	width: 65px;
}
.fil_btn{
	margin-top: 15px;
	margin-left: 15px;
}
.main_head_block{
.head_block{
	margin: 0px;
	padding: 0px; 
	height: 74px
}
.data_notice {
	font-size: larger;
}
.module_heading{
	padding-top:25px;
	height: 29px;
	min-width: 94px;
	color: #000000;
	font-family: Poppins;
	font-size: 21px;
	font-weight: 500;
	letter-spacing: -0.02px;
	line-height: 31px;
}
.add_icon_container{
	height: 43px;
	width: 43px;
	margin-top: 19px;
	margin-bottom: 16px;
	margin-left: 15px;
	padding-left: 2px;
	background-color: #FAFAFA ;
	border-radius: 50%;
	cursor: pointer;
	.icon_add{
		cursor:pointer;
		color: black;
		height: 17px;
		width: 17px;
		opacity: 0.81;
		margin: 13px;
	}
}

.icon_one{
	cursor:pointer;
	color: black;
    height: 18px;
    width: 18px;
    opacity: 0.81;
    margin-top: 32px;
    margin-left: 18px;
}
.icon_two{
	color: black;
    height: 18px;
    width: 18px;
    opacity: 0.81;
    margin-top: 32px;
    margin-left: 6px;
	cursor: pointer;
}
.sel_fil_wrap{
	margin-top:15px;
}
.sel_fil_wrap.one{
	margin-left: 18px;
}
.sel_fil_wrap.two{
	margin-left: 9px;
}
.sel_fil_wrap.three{
	margin-left: 9px;
}
.sel_fil_wrap.four{
	margin-left: 9px;
}
.check_fil_wrap{
	margin-left: 2px;
	margin-top: 34px;
}
.adv_fil_wrap{
	position: absolute;
    right: 21px;
    padding-top: 24px;
}
.head_search{
	height: 43px;
    width: 43px;
    border-radius: 50%;
    background-color: #ffbf3f;
    position: absolute;
    right: 38px;
    top: 15px;
	padding-left: 9px;
    padding-top: 12px;
	.icon{
		padding: 12px 25px 12px 17px;
		height: 18px;
		width: 18px;
		text-align: center;
	}
	.text{
		color: #333;
		font-family: "Nunito Sans";
		font-size: 14px;
		font-weight: 600;
		letter-spacing: -0.03px;
		float: right;
    	margin-right: 10px;	
	}
}
.head_search_inp{
	right: 90px;
    top: 15px;
	position:absolute;
	box-sizing: border-box;
	height: 43px;
	// width: 220px;
	border: 1px solid #979797;
	border-radius: 6px;
	background-color: #FFFFFF;
	margin-left: 10px;
	padding-left:4px;
	padding-right:4px;
	}
}
</style>
